import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';

import App from './containers/App/App';
import Help from './containers/Page/Help';
import AuthWrapper from './containers/AuthWrapper';
import Home from './containers/Home/Home';
import SignUp from './containers/Page/Signup';
import Pricing from './containers/Page/Pricing';
import VideoChat from './containers/Page/VideoChat';
import PublicVideoChat from './containers/Page/VideoChat/PublicVideoChat';

const RestrictedRoute = ({ component: Component, isLoggedIn, hasPremium, ...rest }) => {
  return (<Route
    {...rest}
    render={(props, ...rest) => {
      return isLoggedIn
        ? <Component {...props} hasPremium={hasPremium} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location },
          }}
        />
    }}
  />)
};

const PublicRoutes = ({ history, isLoggedIn, hasPremium }) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path={'/'}
          component={Home}
        />
        <Route
          exact
          path={'/signin'}
          component={AuthWrapper}
        />
        <Route
          exact
          path={'/signup'}
          component={SignUp}
        />
        <Route
          exact
          path={'/pricing'}
          component={Pricing}
        />
        <Route
          exact
          path={'/help'}
          component={Help}
        />
        <Route
          exact
          path={'/public/video/:id?/:therapistId'}
          component={(props) => <PublicVideoChat {...props} />}
        />
        <RestrictedRoute
          path="/video/:id"
          component={VideoChat}
          isLoggedIn={isLoggedIn}
          hasPremium={hasPremium}
        />
        <RestrictedRoute
          path="/app"
          component={App}
          isLoggedIn={isLoggedIn}
          hasPremium={hasPremium}
        />
        <Redirect from="/" to="/signin" />
      </Switch>
    </BrowserRouter>
  );
}


export default connect(state => ({
  isLoggedIn: state.Auth.get('idToken') !== null,
  hasPremium: state.App.get('hasPremium')
}))(PublicRoutes);
